import { Delivery } from '@/types'

export default class MondialRelayAdapter {
  public code: string

  constructor(code: string) {
    this.code = code
  }

  buildTrackingPageUrl(delivery: Delivery, idPackage: number): string {
    const hasMultiplePackages = delivery.packages.length > 1
    const isTrackingByDelivery = delivery.externalDeliveryId.match(/\d{8}/g)

    if (hasMultiplePackages && idPackage === 0 && !isTrackingByDelivery) {
      return ''
    }

    const postalCode = delivery.delivery.address.postalCode
    const language = delivery.delivery.contact.language.toLowerCase() === 'es' ? 'ES' : 'FR'

    let trackingId = null

    trackingId = isTrackingByDelivery
      ? delivery.externalDeliveryId.slice(0, 10)
      : (trackingId = delivery.packages[hasMultiplePackages ? idPackage - 1 : 0]?.id)

    return `http://www.mondialrelay.com/public/permanent/tracking.aspx?exp=${trackingId}&codePostal=${postalCode}&language=${language}`
  }
}
